import { combineText } from '../../../functions/combineText';
import ContentText from '@solid-ui-components/ContentText';
import { Box } from 'theme-ui';
import Instructions from './Instructions';

const styles = {
  textWrapper: {
    margin: '0 auto',
    textAlign: 'center',
    maxWidth: 1110,
  },
  heroContent: {
    padding: '4rem 2rem',
    backgroundColor: '#F6F0F0',
    h1: {
      letterSpacing: '.05em',
      textTransform: 'uppercase',
      lineHeight: 1.2,
    },
    h2: {
      lineHeight: '1.3',
    },
    h5: {
      fontWeight: 300,
      lineHeight: 1.4,
    },
  },
};

export interface HeroDescriptionProps {
  staticContent: any;
  dynamicContent: any;
  isTest?: boolean;
}

function HeroDescription({
  dynamicContent,
  staticContent,
  isTest,
}: HeroDescriptionProps) {
  return (
    <Box sx={styles.heroContent}>
      <Box sx={styles.textWrapper}>
        <ContentText
          content={{
            text:
              dynamicContent?.shareTitle ||
              combineText(staticContent?.kicker?.text || '', [
                dynamicContent?.service?.name || '',
              ]),
          }}
          variant='h1'
        />
        <ContentText
          content={{
            text:
              dynamicContent?.shareDescription ||
              staticContent.kicker.detailedTexts[0].value[0],
          }}
          variant='h5'
        />
      </Box>
      <Instructions
        dynamicContent={{
          ...(isTest && {
            kicker: {
              text: dynamicContent?.joinerKicker,
              inject: [dynamicContent?.service?.name],
            },
          }),
          title: {
            text: isTest
              ? dynamicContent?.joinerTitle
              : dynamicContent.shareTextTitle || dynamicContent?.service?.name
              ? combineText(staticContent.title.text, [
                  dynamicContent?.service?.name,
                ])
              : '',
            inject: isTest ? [dynamicContent?.service?.name] : [],
          },
          step1: {
            title: isTest
              ? dynamicContent?.joinerStep1Title
              : dynamicContent?.shareStep1Title,
            description: isTest
              ? dynamicContent?.joinerStep1Description
              : dynamicContent?.shareStep1Description,
            inject: isTest
              ? [dynamicContent?.service?.name]
              : [dynamicContent?.service?.name],
          },
          step2: {
            title: isTest
              ? dynamicContent?.joinerStep2Title
              : dynamicContent?.shareStep2Title,
            description: isTest
              ? dynamicContent?.joinerStep2Description
              : dynamicContent?.shareStep2Description,
            inject: isTest
              ? []
              : [dynamicContent?.service?.name, dynamicContent.numberOfPerson],
          },
          step3: {
            title: isTest
              ? dynamicContent?.joinerStep3Title
              : dynamicContent?.shareStep3Title,
            description: isTest
              ? dynamicContent?.joinerStep3Description
              : dynamicContent?.shareStep3Description,
            inject: isTest
              ? [dynamicContent?.monthlyPrice, dynamicContent?.service?.name]
              : [dynamicContent.gain, dynamicContent.numberOfPerson],
          },
        }}
        staticContent={staticContent}
      />
    </Box>
  );
}

export default HeroDescription;
